module.exports = __webpack_public_path__ + "static/img/browser2.a51f7bb.webp";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/home/download/browser2.webp
// module id = MqW+
// module chunks = 3